<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">Acciones</th>
        <th class="text-center">Comentarios</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="autorizacion in autorizaciones">

        <tr v-if="autorizacion.idEmpleado === getIdEmpleadoLogueado" :key="autorizaciones.indexOf(autorizacion)">
          <td class="text-center">{{ autorizacion.nombreEmpleado }}</td>
          <td v-if="autorizacion.autorizado === true">
            <p class="text-info text-center">
              Movimiento autorizado
            </p>
          </td>
          <td v-else align="center">
            <b-button-group>
              <b-button
                  v-if="$localStorageService.can('MV_autorizar')"
                  v-on:click="autorizarMovimiento(autorizacion.idMovimiento,autorizacion.idEmpleado)"
                  variant="success"
                  size="sm"
              > Autorizar
              </b-button>
              <b-button
                  @click="showModal(autorizacion)"
                  v-if="$localStorageService.can('MV_ch_estatus_cancelado')"
                  variant="warning"
                  size="sm"
              > Cancelar
              </b-button>
            </b-button-group>




          </td>
          <td>{{autorizacion.comentario}}</td>

        </tr>
        <tr v-else :key="autorizaciones.indexOf(autorizacion)">
          <td class="text-center">{{ autorizacion.nombreEmpleado }}</td>
          <td class="text-center">{{ autorizacion.autorizado === true ? 'Autorizado' : 'No autorizado' }}</td>
          <td>{{autorizacion.comentario}}</td>
        </tr>
      </template>

      </tbody>
    </table>

    <b-modal
        ref="comentario"
        hide-footer
        title="Comentario">
      <p class="my-4" style="text-align: center">
        <b-form v-on:submit.prevent="cambiarEstatusCancelado">
          <b-form-textarea
              id="textarea"
              v-model="comentario"
              placeholder="¿Por qué quieres cancelar el movimiento?"
              rows="3"
              max-rows="6"
              required
          ></b-form-textarea>

          <b-button class="mt-4 mr-2" variant="outline-secondary" @click="hideModal()">
            Cerrar
          </b-button>
          <b-button class="mt-4" variant="outline-success" type="submit">
            Guardar
          </b-button>
        </b-form>
      </p>
    </b-modal>

  </div>
</template>

<script>
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";

export default {
  name: "AutorizarMovimientoConComentario",
  props: {
    autorizaciones: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    movimientoService: new MovimientoService(),
    comentario: null,
    autorizacion: null
  }),
  methods: {
    autorizarMovimiento(idMovimiento, idEmpleado) {
      this.movimientoService.autorizarMovimiento(idMovimiento, idEmpleado);
      this.$root.$emit('reload-traspasos','force')
      this.$root.$emit('reload-movimientos','force')
      this.$root.$emit('reload-reembolsos','force')
      this.$root.$emit('bv::hide::modal','autorizar-'+idMovimiento)
    },
    cambiarEstatusCancelado(){
      this.movimientoService.cambiarEstatusCanceladoConComentario(this.autorizacion.idMovimiento, this.autorizacion.idEmpleado, this.comentario);
      this.hideModal();
      this.$root.$emit('reload-traspasos','force')
      this.$root.$emit('reload-movimientos','force')
      this.$root.$emit('reload-reembolsos','force')
      this.$root.$emit('bv::hide::modal','autorizar-'+this.autorizacion.idMovimiento)
    },
    showModal(autorizacion){
      this.autorizacion = autorizacion;
      this.$refs["comentario"].show();
    },
    hideModal() {
      this.$refs["comentario"].hide();
    },
  },
  computed: {
    getIdEmpleadoLogueado() {
      return this.$localStorageService.getIdEmpleado()
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
